import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

export function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.sixtema.it/" target="_blank">
        Sixtema S.p.A.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();
type ButtonVariantType = "text" | "contained" | "outlined"
export const Signout = ({ href, onSignout, variant = 'contained' }: { href?: string, variant?: ButtonVariantType, onSignout?: () => void }) => {
  const handleLogout = (ev: React.MouseEvent<HTMLButtonElement>) => {
    if(onSignout) {
      ev.preventDefault()
      onSignout()
    }
  }
  return <Button variant={variant} onClick={handleLogout} title='LOGOUT' href={href} sx={{color: '#EDEFF0'}}><LogoutOutlinedIcon color="inherit"/></Button>
}

export const SignIn = ({ onSignin }: { onSignin: (username?: string) => void }) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const username = data.get('username')
    const password = data.get('password')
    if(!username || !password) alert('Inserire user/pass')
    onSignin(username?.toString())
    // eslint-disable-next-line no-console
    console.log({ username, password, });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: 'solid 1px #1565c0',
            borderRadius: '0.5rem',
            padding: '1rem',
            backgroundColor: 'rgba(255,255,255,0.5)',
          }}
        >
          <img src="/MySixtema.png" alt='MySixtema' height={42} />
          <Typography component="h1" variant="h5" sx={{ mt: '1rem' }}>Sign in</Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField margin="normal" required fullWidth id="username" label="Username" name="username" autoComplete="username" autoFocus />
            <TextField margin="normal" required fullWidth name="password" label="Password" type="password" id="password" autoComplete="current-password" />
            <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>Sign In</Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Password dimenticata?
                </Link>
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Cambio password"}
                </Link>
              </Grid>
            </Grid>
          </Box>
          <Copyright sx={{ mt: 8, mb: 0 }} />
        </Box>
      </Container>
    </ThemeProvider>
  );
}